(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chat-photo-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  initChatReviews();
});

document.addEventListener("shopify:section:load", () => {
  initChatReviews();
});

function initChatReviews() {
  const sections = document.querySelectorAll('.cpr');
  
  sections.forEach(section => {
    const triggers = section.querySelectorAll('[data-lightbox-trigger]');
    const lightbox = section.querySelector('[data-chat-lightbox]');
    
    if (!lightbox || triggers.length === 0) return;

    const overlay = lightbox.querySelector('.cpr-lightbox__overlay');
    const closeBtn = lightbox.querySelector('.cpr-lightbox__close');
    const imageEl = lightbox.querySelector('.cpr-lightbox__image');

    const openLightbox = (imgUrl) => {
      imageEl.src = imgUrl;
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => { imageEl.src = ''; }, 300);
    };

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const fullSizeUrl = trigger.getAttribute('data-lightbox-trigger');
        if (fullSizeUrl) openLightbox(fullSizeUrl);
      });
    });

    if (overlay) overlay.addEventListener('click', closeLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.classList.contains('active')) {
        closeLightbox();
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-video-reviews"] && !Shopify.designMode) return;
  try {
    
/*
==================================================
 Customer Video Reviews
 Premium Carousel v1.3 (Center-Snap Conflict Fix)
==================================================
*/

class CustomerVideoReviews {
  constructor(section) {
    this.section = section;
    this.section.__carouselInstance = this;

    this.track = section.querySelector("[data-carousel-track]");
    this.cards = [...section.querySelectorAll("[data-card]")];

    this.prevBtn = section.querySelector(".cvr__prev");
    this.nextBtn = section.querySelector(".cvr__next");

    this.modal = section.querySelector("[data-modal]");
    this.modalVideo = section.querySelector(".cvr-modal__video");
    this.modalOverlay = section.querySelector(".cvr-modal__overlay");
    this.modalClose = section.querySelector(".cvr-modal__close");

    this.current = 0;
    this.dragging = false;
    this.startX = 0;
    this.startScroll = 0;

    this.autoplay = null;
    this.autoplayDelay = 4000;
    this.snapTimeout = null;

    this.init();
  }

  init() {
    this.bindEvents();
    
    // Short timeout allows the browser to render layouts before calculating offsets
    setTimeout(() => {
      this.scrollToCard(0, false);
    }, 100);
    
    this.startAutoplay();

    window.addEventListener("resize", () => {
      this.scrollToCard(this.current, false);
    });
  }

  bindEvents() {
    this.nextBtn?.addEventListener("click", () => this.next());
    this.prevBtn?.addEventListener("click", () => this.prev());

    this.track.addEventListener("mouseenter", () => this.stopAutoplay());
    this.track.addEventListener("mouseleave", () => this.startAutoplay());

    this.enableDragging();
    this.enableModal();
  }

  next() {
    this.current++;
    if (this.current >= this.cards.length) this.current = 0;
    this.scrollToCard(this.current);
  }

  prev() {
    this.current--;
    if (this.current < 0) this.current = this.cards.length - 1;
    this.scrollToCard(this.current);
  }

  scrollToCard(index, smooth = true) {
    if (!this.cards[index] || !this.track) return;

    // 1. Temporarily kill native snapping so it doesn't fight the JavaScript animation
    this.track.style.scrollSnapType = "none";

    const card = this.cards[index];
    
    // 2. Math formula to calculate a clean center-aligned scroll target
    const targetLeft = card.offsetLeft - (this.track.clientWidth / 2) + (card.clientWidth / 2);

    this.track.scrollTo({
      left: targetLeft,
      behavior: smooth ? "smooth" : "auto"
    });

    this.updateCardClasses(index);

    // 3. Re-enable native scroll snapping safely once the smooth animation completes
    clearTimeout(this.snapTimeout);
    if (smooth) {
      this.snapTimeout = setTimeout(() => {
        this.track.style.scrollSnapType = "x mandatory";
      }, 500); 
    } else {
      this.track.style.scrollSnapType = "x mandatory";
    }
  }

  updateCardClasses(activeIndex) {
    this.cards.forEach((card, index) => {
      card.classList.remove("active", "neighbor");
      if (index === activeIndex) {
        card.classList.add("active");
      } else if (index === activeIndex - 1 || index === activeIndex + 1) {
        card.classList.add("neighbor");
      }
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplay = setInterval(() => this.next(), this.autoplayDelay);
  }

  stopAutoplay() {
    clearInterval(this.autoplay);
  }

  enableDragging() {
    this.track.addEventListener("pointerdown", (e) => {
      this.dragging = true;
      this.startX = e.clientX;
      this.startScroll = this.track.scrollLeft;
      this.track.setPointerCapture(e.pointerId);
      this.track.classList.add("dragging");
      
      // Turn off snapping immediately while dragging manually
      this.track.style.scrollSnapType = "none";
      this.stopAutoplay();
    });

    this.track.addEventListener("pointermove", (e) => {
      if (!this.dragging) return;
      const walk = e.clientX - this.startX;
      this.track.scrollLeft = this.startScroll - walk;
    });

    const stopDragging = () => {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.classList.remove("dragging");
      this.snapToNearest();
      this.startAutoplay();
    };

    this.track.addEventListener("pointerup", stopDragging);
    this.track.addEventListener("pointercancel", stopDragging);
  }

  snapToNearest() {
    // Finds which card layout center point is closest to the track's viewport center
    const trackCenter = this.track.scrollLeft + (this.track.clientWidth / 2);
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.cards.forEach((card, index) => {
      const cardCenter = card.offsetLeft + (card.clientWidth / 2);
      const distance = Math.abs(trackCenter - cardCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    this.current = closestIndex;
    this.scrollToCard(this.current);
  }

  enableModal() {
    this.cards.forEach(card => {
      const videoWrapper = card.querySelector("[data-video]");
      const originalVideo = card.querySelector("video");

      if (!videoWrapper || !originalVideo) return;

      videoWrapper.addEventListener("click", () => {
        const modalVideoEl = document.createElement("video");
        modalVideoEl.controls = true;
        modalVideoEl.autoplay = true;
        modalVideoEl.playsInline = true;
        
        if (originalVideo.src) {
          modalVideoEl.src = originalVideo.src;
        } else {
          originalVideo.querySelectorAll("source").forEach(source => {
            modalVideoEl.appendChild(source.cloneNode(true));
          });
        }

        this.modalVideo.innerHTML = "";
        this.modalVideo.appendChild(modalVideoEl);
        this.modal.classList.add("active");
        document.body.style.overflow = "hidden";
        this.stopAutoplay();

        modalVideoEl.play().catch(err => console.log("Playback blocked:", err));
      });
    });

    this.modalOverlay?.addEventListener("click", () => this.closeModal());
    this.modalClose?.addEventListener("click", () => this.closeModal());
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.closeModal();
    });
  }

  closeModal() {
    this.modal.classList.remove("active");
    
    const modalVideoEl = this.modalVideo.querySelector("video");
    if (modalVideoEl) {
      modalVideoEl.pause();
      modalVideoEl.src = "";
      modalVideoEl.removeAttribute("src");
      modalVideoEl.innerHTML = "";
      modalVideoEl.load(); 
    }

    this.modalVideo.innerHTML = "";
    document.body.style.overflow = "";
    this.startAutoplay();
  }
}

/*
==================================================
 SHOPIFY THEME EDITOR EVENT LISTENERS
==================================================
*/
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cvr").forEach(section => new CustomerVideoReviews(section));
});

document.addEventListener("shopify:section:load", (e) => {
  const section = e.target.querySelector(".cvr");
  if (section) new CustomerVideoReviews(section);
});

document.addEventListener("shopify:section:unload", (e) => {
  const section = e.target.querySelector(".cvr");
  if (section && section.__carouselInstance) {
    section.__carouselInstance.stopAutoplay();
  }
});

document.addEventListener("shopify:block:select", (e) => {
  const card = e.target.closest("[data-card]");
  if (!card) return;
  
  const section = card.closest(".cvr");
  if (section && section.__carouselInstance) {
    const instance = section.__carouselInstance;
    const index = instance.cards.indexOf(card);
    
    if (index !== -1) {
      instance.current = index;
      instance.scrollToCard(index, true);
      instance.stopAutoplay();
    }
  }
});

document.addEventListener("shopify:block:deselect", (e) => {
  const card = e.target.closest("[data-card]");
  if (!card) return;
  
  const section = card.closest(".cvr");
  if (section && section.__carouselInstance) {
    section.__carouselInstance.startAutoplay();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
